import * as React from "react";
import { IProcessComponentProps, ProcessComponent } from "../../../../../Shared/Process/Process/ProcessComponent";
import { UpdateLifetimeAllowanceContent } from "../Resource/Content";
import { PercentageTextBoxEditor } from "../../../../../../react-core/Html/PercentageTextBoxEditor";
import { OffPlatformLifeTimeAllowance } from "../../../../../../Wrap/Models/Domains/Account/OffPlatformLifeTimeAllowance";
import { AccountLifeTimeAllowance } from "../../../../../../Wrap/Models/Domains/Account/AccountLifeTimeAllowance";
import { UpdateLifetimeAllowanceAction } from "../Actions/UpdateLifetimeAllowanceAction";

interface IUpdateLifetimeAllowanceDetailProps extends IProcessComponentProps {
    extraInfo: any;
}

interface IUpdateLifetimeAllowanceDetailPropsState {
    lifetimeAllowanceOffPlatform: number;
}

export class UpdateLifetimeAllowanceDetail extends ProcessComponent<
    IUpdateLifetimeAllowanceDetailProps,
    IUpdateLifetimeAllowanceDetailPropsState
> {
    constructor(props: any) {
        super(props);
        this.state = {
            lifetimeAllowanceOffPlatform: 0,
        };
    }

    private getOnPlatformData(): AccountLifeTimeAllowance {
        return this.props.extraInfo?.onPlatformData;
    }

    private getOffPlatformData(): OffPlatformLifeTimeAllowance {
        return this.props.extraInfo?.offPlatformData;
    }

    private GetLtaPreviouslyCrystallisedOnPlatform(): number {
        return this.getOnPlatformData().UsedOnfPlatformAllowance;
    }

    private GetLtaUsedByBenefitsThatCommencedPriorToDate(): number {
        return this.getOnPlatformData().UsedByBenefitsPrior472006;
    }

    private GetLtaUsed(): number {
        return (
            this.getOnPlatformData().UsedOnfPlatformAllowance +
            this.getOnPlatformData().UsedByBenefitsPrior472006 +
            this.getOffPlatformData().LifeTimeAllowanceUsedPercentage
        );
    }

    public GetOffPlatformLifeTimeAllowance(): number {
        return this.getOnPlatformData().UsedOffPlatformAllowance;
    }

    render() {
        return (
            <>
                <h2>{UpdateLifetimeAllowanceContent.ltaDetails}</h2>
                <h3>
                    <b>{UpdateLifetimeAllowanceContent.ltaPreviouslyCrystallisedOnPlatform}</b>
                </h3>
                <td className="cell-right">{this.GetLtaPreviouslyCrystallisedOnPlatform().toFixed(2)}%</td>
                <h3>
                    <b>{UpdateLifetimeAllowanceContent.ltaUsedByBenefitsThatCommencedPriorToDate}</b>
                </h3>
                <td className="cell-right">{this.GetLtaUsedByBenefitsThatCommencedPriorToDate().toFixed(2)}%</td>
                <div className="col-4">
                    <PercentageTextBoxEditor
                        label={UpdateLifetimeAllowanceContent.ltaCrystallisedOffPlatform}
                        value={this.state.lifetimeAllowanceOffPlatform}
                        atMost={{
                            errorMessage: UpdateLifetimeAllowanceContent.messages.percentageOver100,
                            value: 100,
                        }}
                        atLeast={{
                            errorMessage: UpdateLifetimeAllowanceContent.messages.percentageUnder0,
                            value: 0,
                        }}
                        onChange={(v) => {
                            this.setState({ lifetimeAllowanceOffPlatform: v });
                            UpdateLifetimeAllowanceAction.updateInstruction(v);
                        }}
                        required={"Please enter a percentage"}
                    />
                </div>
                <h3>
                    <b>{UpdateLifetimeAllowanceContent.ltaUsed}</b>
                </h3>
                <td className="cell-right">{this.GetLtaUsed()}%</td>
            </>
        );
    }
}
